import Api from '@/plugins/axios';
import { VUE_APP_GCN_SERVICES } from '@/constants';
import { ParecerReferencialRenovacao } from '../types';

const BASE_URL = `${VUE_APP_GCN_SERVICES}/parecer/referencial/renovacao`;

class ParecerReferencialRenovacaoService {
  public async listar(cdParecerReferencial: number) {
    return Api.get<ParecerReferencialRenovacao[]>(`${BASE_URL}/listar`, {
      params: { cdParecerReferencial },
    });
  }

  public async renovar(
    parecerReferencialRenovacao: ParecerReferencialRenovacao
  ) {
    return Api.put(`${BASE_URL}/renovar`, parecerReferencialRenovacao);
  }
}

export default new ParecerReferencialRenovacaoService();
